export const get_pixel_width = my_string => {
  if (!my_string || 0 === my_string.length) {
    return 0;
  }

  // This collection (array of objects) comes from a separate tool. Represents all unique ligatures and character widths.
  var character_sizes = [
    { ' ': 5 },
    { '!': 5 },
    { '"': 6.375 },
    { '#': 10 },
    { $: 10 },
    { '%': 16 },
    { '&': 12 },
    { "'": 3.421875 },
    { '(': 5.984375 },
    { ')': 5.984375 },
    { '*': 7 },
    { '+': 10.5 },
    { ',': 5 },
    { '-': 5.984375 },
    { '.': 5 },
    { '/': 5 },
    { '0': 10 },
    { '1': 10 },
    { '2': 10 },
    { '3': 10 },
    { '4': 10 },
    { '5': 10 },
    { '6': 10 },
    { '7': 10 },
    { '8': 10 },
    { '9': 10 },
    { ':': 5 },
    { ';': 5 },
    { '<': 10.5 },
    { '=': 10.5 },
    { '>': 10.5 },
    { '?': 10 },
    { '@': 18.265625 },
    { A: 12 },
    { B: 12 },
    { C: 12.984375 },
    { D: 12.984375 },
    { E: 12 },
    { F: 10.984375 },
    { G: 14 },
    { H: 12.984375 },
    { I: 5 },
    { J: 9 },
    { K: 12 },
    { L: 10 },
    { M: 14.984375 },
    { N: 12.984375 },
    { O: 14 },
    { P: 12 },
    { Q: 14 },
    { R: 12.984375 },
    { S: 12 },
    { T: 10.984375 },
    { U: 12.984375 },
    { V: 12 },
    { W: 16.984375 },
    { X: 12 },
    { Y: 12 },
    { Z: 10.984375 },
    { '[': 5 },
    { '\\': 5 },
    { ']': 5 },
    { '^': 8.4375 },
    { _: 10 },
    { '`': 5.984375 },
    { a: 10 },
    { b: 10 },
    { c: 9 },
    { d: 10 },
    { e: 10 },
    { f: 5 },
    { g: 10 },
    { h: 10 },
    { i: 3.984375 },
    { j: 3.984375 },
    { k: 9 },
    { l: 3.984375 },
    { m: 14.984375 },
    { n: 10 },
    { o: 10 },
    { p: 10 },
    { q: 10 },
    { r: 5.984375 },
    { s: 9 },
    { t: 5 },
    { u: 10 },
    { v: 9 },
    { w: 12.984375 },
    { x: 9 },
    { y: 9 },
    { z: 9 },
    { '{': 6 },
    { '|': 4.671875 },
    { '}': 6 },
    { '~': 10.5 },
    { ' A': 16 },
    { ' T': 15.65625 },
    { ' Y': 16.671875 },
    { '"@': 24.65625 },
    { '"|': 11.0625 },
    { '#^': 18.453125 },
    { '$^': 18.453125 },
    { "''": 6.859375 },
    { '+^': 18.953125 },
    { '0^': 18.453125 },
    { '11': 18.671875 },
    { '1^': 18.453125 },
    { '2^': 18.453125 },
    { '3^': 18.453125 },
    { '4^': 18.453125 },
    { '5^': 18.453125 },
    { '6^': 18.453125 },
    { '7^': 18.453125 },
    { '8^': 18.453125 },
    { '9^': 18.453125 },
    { '<^': 18.953125 },
    { '=^': 18.953125 },
    { '>^': 18.953125 },
    { '?^': 18.453125 },
    { '@"': 24.65625 },
    { 'A ': 16 },
    { AT: 21.65625 },
    { AV: 22.671875 },
    { AW: 28.3125 },
    { AY: 22.671875 },
    { Av: 20.671875 },
    { Aw: 24.671875 },
    { Ay: 20.671875 },
    { 'F,': 14 },
    { 'F.': 14 },
    { FA: 22 },
    { 'L ': 14.34375 },
    { LT: 19.65625 },
    { LV: 20.671875 },
    { LW: 25.65625 },
    { LY: 20.671875 },
    { 'L^': 18.453125 },
    { Ly: 18.328125 },
    { 'P ': 16.671875 },
    { 'P,': 14.671875 },
    { 'P.': 14.671875 },
    { PA: 22.671875 },
    { RT: 23.65625 },
    { RV: 24.671875 },
    { RW: 29.65625 },
    { RY: 24.671875 },
    { 'T ': 15.65625 },
    { 'T,': 14 },
    { 'T-': 15.984375 },
    { 'T.': 14 },
    { 'T:': 14 },
    { 'T;': 14 },
    { TA: 21.65625 },
    { TO: 24.65625 },
    { Ta: 19 },
    { Tc: 18 },
    { Te: 19 },
    { Ti: 14.3125 },
    { To: 19 },
    { Tr: 16.3125 },
    { Ts: 18 },
    { Tu: 20.328125 },
    { Tw: 23 },
    { Ty: 19 },
    { 'V,': 15.34375 },
    { 'V-': 17 },
    { 'V.': 15.34375 },
    { 'V:': 16.328125 },
    { 'V;': 16.328125 },
    { VA: 22.671875 },
    { Va: 20.671875 },
    { Ve: 21.015625 },
    { Vi: 15.671875 },
    { Vo: 21.015625 },
    { Vr: 17.328125 },
    { Vu: 21.34375 },
    { Vy: 20.328125 },
    { 'W,': 20.984375 },
    { 'W-': 22.65625 },
    { 'W.': 20.984375 },
    { 'W:': 21.65625 },
    { 'W;': 21.65625 },
    { WA: 28.3125 },
    { Wa: 26.328125 },
    { We: 26.671875 },
    { Wo: 26.671875 },
    { Wr: 22.65625 },
    { Wu: 26.671875 },
    { Wy: 25.828125 },
    { 'Y ': 16.671875 },
    { 'Y,': 14.671875 },
    { 'Y-': 16.34375 },
    { 'Y.': 14.671875 },
    { 'Y:': 16 },
    { 'Y;': 15.828125 },
    { YA: 22.671875 },
    { Ya: 20.671875 },
    { Ye: 20.359375 },
    { Yi: 15.328125 },
    { Yo: 20.359375 },
    { Yp: 20.671875 },
    { Yq: 20.359375 },
    { Yu: 21.015625 },
    { Yv: 20 },
    { '^#': 18.453125 },
    { '^$': 18.453125 },
    { '^+': 18.953125 },
    { '^0': 18.453125 },
    { '^1': 18.453125 },
    { '^2': 18.453125 },
    { '^3': 18.453125 },
    { '^4': 18.453125 },
    { '^5': 18.453125 },
    { '^6': 18.453125 },
    { '^7': 18.453125 },
    { '^8': 18.453125 },
    { '^9': 18.453125 },
    { '^<': 18.953125 },
    { '^=': 18.953125 },
    { '^>': 18.953125 },
    { '^?': 18.453125 },
    { '^L': 18.453125 },
    { '^_': 18.453125 },
    { '^a': 18.453125 },
    { '^b': 18.453125 },
    { '^d': 18.453125 },
    { '^e': 18.453125 },
    { '^g': 18.453125 },
    { '^h': 18.453125 },
    { '^n': 18.453125 },
    { '^o': 18.453125 },
    { '^p': 18.453125 },
    { '^q': 18.453125 },
    { '^u': 18.453125 },
    { '^{': 14.453125 },
    { '^}': 14.453125 },
    { '^~': 18.953125 },
    { '_^': 18.453125 },
    { 'a^': 18.453125 },
    { 'b^': 18.453125 },
    { 'd^': 18.453125 },
    { 'e^': 18.453125 },
    { ff: 9.671875 },
    { 'g^': 18.453125 },
    { 'h^': 18.453125 },
    { 'n^': 18.453125 },
    { 'o^': 18.453125 },
    { 'p^': 18.453125 },
    { 'q^': 18.453125 },
    { 'r,': 10 },
    { 'r.': 10 },
    { 'u^': 18.453125 },
    { 'v,': 12.65625 },
    { 'v.': 12.65625 },
    { 'w,': 17 },
    { 'w.': 17 },
    { 'y,': 12.65625 },
    { 'y.': 12.65625 },
    { '{^': 14.453125 },
    { '|"': 11.0625 },
    { '}^': 14.453125 },
    { '~^': 18.953125 }
  ];

  var total_width = 0;

  // For every character, see if it's a ligature with the following & add ligature width. If not, add the normal character's width.
  for (var i = 0, len = my_string.length; i < len; i++) {
    var current_char = my_string.charAt(i);
    var ligature_width = 0;
    var current_ligature = '';
    if (i + 1 < len) {
      current_ligature = current_char + my_string.charAt[i + 1];
      ligature_width = gpw_get_value(character_sizes, current_ligature);
    }
    if (ligature_width) {
      i++;
      total_width += ligature_width;
    } else {
      total_width += gpw_get_value(character_sizes, current_char);
    }
  }

  // Rounding to 1 decimal place.
  var result = Math.round(total_width * 10) / 10;

  return result.toFixed();
};

function gpw_get_value(collection, key) {
  var result = collection.filter(function(obj) {
    return obj.hasOwnProperty(key);
  });
  try {
    return result[0][key];
  } catch (err) {
    return false;
  }
}

export const countryCodes = {
  abw: 'Aruba',
  afg: 'Afghanistan',
  ago: 'Angola',
  aia: 'Anguilla',
  ala: 'Aland Islands',
  alb: 'Albania',
  and: 'Andorra',
  ant: 'Netherlands Antilles',
  are: 'United Arab Emirates',
  arg: 'Argentina',
  arm: 'Armenia',
  asm: 'American Samoa',
  ata: 'Antarctica',
  atf: 'French Southern Territories',
  atg: 'Antigua and Barbuda',
  aus: 'Australia',
  aut: 'Austria',
  aze: 'Azerbaijan',
  bdi: 'Burundi',
  bel: 'Belgium',
  ben: 'Benin',
  bfa: 'Burkina Faso',
  bgd: 'Bangladesh',
  bgr: 'Bulgaria',
  bhr: 'Bahrain',
  bhs: 'Bahamas',
  bih: 'Bosnia and Herzegovina',
  blm: 'Saint Barthélemy',
  blr: 'Belarus',
  blz: 'Belize',
  bmu: 'Bermuda',
  bol: 'Bolivia, Plurinational State of',
  bra: 'Brazil',
  brb: 'Barbados',
  brn: 'Brunei Darussalam',
  btn: 'Bhutan',
  bvt: 'Bouvet Island',
  bwa: 'Botswana',
  caf: 'Central African Republic',
  can: 'Canada',
  cck: 'Cocos (Keeling) Islands',
  che: 'Switzerland',
  chl: 'Chile',
  chn: 'China',
  civ: "Côte d'Ivoire",
  cmr: 'Cameroon',
  cod: 'Congo',
  cog: 'Congo',
  cok: 'Cook Islands',
  col: 'Colombia',
  com: 'Comoros',
  cpv: 'Cape Verde',
  cri: 'Costa Rica',
  cub: 'Cuba',
  cxr: 'Christmas Island',
  cym: 'Cayman Islands',
  cyp: 'Cyprus',
  cze: 'Czech Republic',
  deu: 'Germany',
  dji: 'Djibouti',
  dma: 'Dominica',
  dnk: 'Denmark',
  dom: 'Dominican Republic',
  dza: 'Algeria',
  ecu: 'Ecuador',
  egy: 'Egypt',
  eri: 'Eritrea',
  esh: 'Western Sahara',
  esp: 'Spain',
  est: 'Estonia',
  eth: 'Ethiopia',
  fin: 'Finland',
  fji: 'Fiji',
  flk: 'Falkland Islands (Malvinas)',
  fra: 'France',
  fro: 'Faroe Islands',
  fsm: 'Micronesia',
  gab: 'Gabon',
  gbr: 'United Kingdom',
  geo: 'Georgia',
  ggy: 'Guernsey',
  gha: 'Ghana',
  gib: 'Gibraltar',
  gin: 'Guinea',
  glp: 'Guadeloupe',
  gmb: 'Gambia',
  gnb: 'Guinea-Bissau',
  gnq: 'Equatorial Guinea',
  grc: 'Greece',
  grd: 'Grenada',
  grl: 'Greenland',
  gtm: 'Guatemala',
  guf: 'French Guiana',
  gum: 'Guam',
  guy: 'Guyana',
  hkg: 'Hong Kong',
  hmd: 'Heard Island and McDonald Islands',
  hnd: 'Honduras',
  hrv: 'Croatia',
  hti: 'Haiti',
  hun: 'Hungary',
  idn: 'Indonesia',
  imn: 'Isle of Man',
  ind: 'India',
  iot: 'British Indian Ocean Territory',
  irl: 'Ireland',
  irn: 'Iran',
  irq: 'Iraq',
  isl: 'Iceland',
  isr: 'Israel',
  ita: 'Italy',
  jam: 'Jamaica',
  jey: 'Jersey',
  jor: 'Jordan',
  jpn: 'Japan',
  kaz: 'Kazakhstan',
  ken: 'Kenya',
  kgz: 'Kyrgyzstan',
  khm: 'Cambodia',
  kir: 'Kiribati',
  kna: 'Saint Kitts and Nevis',
  kor: 'Korea',
  kwt: 'Kuwait',
  lao: "Lao People's Democratic Republic",
  lbn: 'Lebanon',
  lbr: 'Liberia',
  lby: 'Libyan Arab Jamahiriya',
  lca: 'Saint Lucia',
  lie: 'Liechtenstein',
  lka: 'Sri Lanka',
  lso: 'Lesotho',
  ltu: 'Lithuania',
  lux: 'Luxembourg',
  lva: 'Latvia',
  mac: 'Macao',
  maf: 'Saint Martin (French part)',
  mar: 'Morocco',
  mco: 'Monaco',
  mda: 'Moldova',
  mdg: 'Madagascar',
  mdv: 'Maldives',
  mex: 'Mexico',
  mhl: 'Marshall Islands',
  mkd: 'Macedonia',
  mli: 'Mali',
  mlt: 'Malta',
  mmr: 'Myanmar',
  mne: 'Montenegro',
  mng: 'Mongolia',
  mnp: 'Northern Mariana Islands',
  moz: 'Mozambique',
  mrt: 'Mauritania',
  msr: 'Montserrat',
  mtq: 'Martinique',
  mus: 'Mauritius',
  mwi: 'Malawi',
  mys: 'Malaysia',
  myt: 'Mayotte',
  nam: 'Namibia',
  ncl: 'New Caledonia',
  ner: 'Niger',
  nfk: 'Norfolk Island',
  nga: 'Nigeria',
  nic: 'Nicaragua',
  niu: 'Niue',
  nld: 'Netherlands',
  nor: 'Norway',
  npl: 'Nepal',
  nru: 'Nauru',
  nzl: 'New Zealand',
  omn: 'Oman',
  pak: 'Pakistan',
  pan: 'Panama',
  pcn: 'Pitcairn',
  per: 'Peru',
  phl: 'Philippines',
  plw: 'Palau',
  png: 'Papua New Guinea',
  pol: 'Poland',
  pri: 'Puerto Rico',
  prk: 'Korea',
  prt: 'Portugal',
  pry: 'Paraguay',
  pse: 'Palestinian Territory',
  pyf: 'French Polynesia',
  qat: 'Qatar',
  reu: 'Réunion',
  rou: 'Romania',
  rus: 'Russian Federation',
  rwa: 'Rwanda',
  sau: 'Saudi Arabia',
  sdn: 'Sudan',
  sen: 'Senegal',
  sgp: 'Singapore',
  sgs: 'South Georgia and the South Sandwich Islands',
  shn: 'Saint Helena, Ascension and Tristan da Cunha',
  sjm: 'Svalbard and Jan Mayen',
  slb: 'Solomon Islands',
  sle: 'Sierra Leone',
  slv: 'El Salvador',
  smr: 'San Marino',
  som: 'Somalia',
  spm: 'Saint Pierre and Miquelon',
  srb: 'Serbia',
  stp: 'Sao Tome and Principe',
  sur: 'Suriname',
  svk: 'Slovakia',
  svn: 'Slovenia',
  swe: 'Sweden',
  swz: 'Swaziland',
  syc: 'Seychelles',
  syr: 'Syrian Arab Republic',
  tca: 'Turks and Caicos Islands',
  tcd: 'Chad',
  tgo: 'Togo',
  tha: 'Thailand',
  tjk: 'Tajikistan',
  tkl: 'Tokelau',
  tkm: 'Turkmenistan',
  tls: 'Timor-Leste',
  ton: 'Tonga',
  tto: 'Trinidad and Tobago',
  tun: 'Tunisia',
  tur: 'Turkey',
  tuv: 'Tuvalu',
  twn: 'Taiwan',
  tza: 'Tanzania',
  uga: 'Uganda',
  ukr: 'Ukraine',
  umi: 'United States Minor Outlying Islands',
  ury: 'Uruguay',
  usa: 'United States',
  uzb: 'Uzbekistan',
  vat: 'Holy See (Vatican City State)',
  vct: 'Saint Vincent and the Grenadines',
  ven: 'Venezuela',
  vgb: 'Virgin Islands, British',
  vir: 'Virgin Islands, U.S.',
  vnm: 'Viet Nam',
  vut: 'Vanuatu',
  wlf: 'Wallis and Futuna',
  wsm: 'Samoa',
  yem: 'Yemen',
  zaf: 'South Africa',
  zmb: 'Zambia',
  zwe: 'Zimbabwe',
  zzz: 'Unspecified'
};

export const formatQueriesForFiveW = options => {
  const { queries, queriesFiveWToggle } = options;
  const queryKeywords = [];

  function generateQueryRegex(queryFilter) {
    switch (queryFilter) {
      case 'all':
        return /^(who\s|what\s|where\s|why\s|how\s|can\s|does\s)/;
      case false:
        return /.*/;
      default:
        return new RegExp(`^${queriesFiveWToggle} `);
    }
  }

  function pushQueryKeyword(queriesFiveWToggle, queryKw) {
    const queryRegex = generateQueryRegex(queriesFiveWToggle);
    return queryRegex.test(queryKw) ? true : false;
  }

  for (var i = 0, len = queries.length; i <= len; i++) {
    if (!queries[i]) continue;
    const queryKw = queries[i].keys[0];

    const queryToPush = pushQueryKeyword(queriesFiveWToggle, queryKw);
    if (queryToPush) {
      queryKeywords.push(queries[i]);
    }
  }

  return queryKeywords;
};

export const getKeywordsByPosition = options => {
  const { queries, positionFilter } = options;
  const keywordsByPosition = [];
  for (var i = 0, len = queries.length; i <= len; i++) {
    if (!queries[i]) continue;
    const position = queries[i].position;
    switch (positionFilter) {
      case '1':
        if (position >= 5 && position <= 10) keywordsByPosition.push(queries[i]);
        break;
      case '2':
        if (position >= 10 && position <= 20) keywordsByPosition.push(queries[i]);
        break;
      case '3':
        if (position >= 20 && position <= 30) keywordsByPosition.push(queries[i]);
        break;
      default:
        keywordsByPosition.push(queries[i]);
    }
  }
  return keywordsByPosition;
}

export const formatNumber = amt => {
  return new Intl.NumberFormat('en-US').format(amt);
};

export const stringToBoolean = value => {
  switch(value) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return false;
  }
}

export const getPagesBySearchQuery = (searchQuery, pages) => {
  const isSearchQuery = searchQuery !== '' ? true : false;

  const pagesWithQuery = [];
  for (let i = 0, len = pages.length; i < len; i++) {
    if (!pages[i]) continue;
    const page = pages[i].keys[0];

    if (!page.includes(searchQuery) || !isSearchQuery) continue;
    pagesWithQuery.push(pages[i]);
  }

  return isSearchQuery && pagesWithQuery.length === 0 ? false : pagesWithQuery;
}



// WEBPACK FOOTER //
// ./src/helpers.js